import gql from "graphql-tag";
import graphqlClient, { fragments } from "@/http/graphql/link";

export const GET_ROLES = `
	roles (limit: $limit, page: $page) {
		...UserRole
	}
`;

const ADD_ROLE = `
	role_add(name: $name, description: $description, permissions: $permissions){
		id
		name
		permissions
	}`;

const UPDATE_ROLE = `
	role_update(id: $id, name: $name, description: $description, permissions: $permissions){
		id
		name
		permissions
	}`;

const ROLE_DELETE = `role_delete(id: $id)`;

const MODULE_ROLES = `
	module_roles (module_name: $module_name) {
		group_name
		permissions {
			name
			permission 
		}
 	}`;

export default {
	init() {},

	fetchRoles(payload) {
		const queryOptions = {
			query: gql`query Roles ($limit: Int!, $page: Int!) {
				${GET_ROLES}
			}
			${fragments.UserRole}
			`,
			variables: {
				limit: payload.limit || -1,
				page: payload.page || 1
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => {
			return {
				roles: response.data.roles
			};
		});
	},
	fetchModuleRoles(payload) {
		const queryOptions = {
			query: gql`query ModuleRoles ($module_name: String!) {
				${MODULE_ROLES}
			}
			`,
			variables: {
				module_name: payload.module_name || "cmcbs"
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => {
			return {
				module_roles: response.data.module_roles
			};
		});
	},
	addRole(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation AddRole ($name: String!, $permissions: String!, $description: String!) {
							${ADD_ROLE}
						}
					`,
				variables: {
					name: payload.name,
					permissions: payload.permissions,
					description: payload.description || ""
				}
			})
			.then(response => {
				return { role_add: response.data.role_add };
			});
	},
	updateRole(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation UppdateRole ($id: Int!, $name: String!, $permissions: String!, $description: String!) {
							${UPDATE_ROLE}
						}
					`,
				variables: {
					id: payload.id,
					name: payload.name,
					permissions: payload.permissions,
					description: payload.description || ""
				}
			})
			.then(response => {
				return { role_update: response.data.role_update };
			});
	},
	deleteRole(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation DeleteRole ($id: Int!) {
							${ROLE_DELETE}
						}
					`,
				variables: {
					id: payload.id
				}
			})
			.then(response => {
				return { role_delete: response.data.role_delete };
			});
	}
};
